export const allRequestHeaders = [
  {
    title: "Request ID",
    key: "request_id",
  },
  {
    title: "Store Name",
    key: "store_name",
  },
  {
    title: "Type",
    key: "request_type",
  },
  {
    title: "Date & Time",
    key: "created_at",
  },

  {
    title: "Status",
    key: "approval_status",
  },
  {
    title: "Action",
    key: "",
    viewbtn: true,
  },
];

export const pendingHeaders = [
  {
    title: "Request ID",
    key: "request_id",
  },
  {
    title: "Store Name",
    key: "store_name",
  },
  {
    title: "Type",
    key: "request_type",
  },
  {
    title: "Date & Time",
    key: "created_at",
  },
  {
    title: "Action",
    key: "",
    viewbtn: true,
  },
];

export const approvedHeaders = [
  {
    title: "Request ID",
    key: "request_id",
  },
  {
    title: "Store Name",
    key: "store_name",
  },
  {
    title: "Type",
    key: "request_type",
  },
  {
    title: "Date & Time",
    key: "created_at",
  },
  {
    title: "Action",
    key: "",
    viewbtn: true,
  },
];

export const rejectedHeaders = [
  {
    title: "Request ID",
    key: "request_id",
  },
  {
    title: "Store Name",
    key: "store_name",
  },
  {
    title: "Type",
    key: "request_type",
  },
  {
    title: "Date & Time",
    key: "created_at",
  },
  {
    title: "Comment",
    key: "comments",
  },
  {
    title: "Action",
    key: "",
    viewbtn: true,
  },
];

export const userTableeaders = [
  {
    title: "Employee Name",
    key: "name",
  },
  {
    title: "Username",
    key: "username",
  },
  {
    title: "Role",
    key: "role",
  },
  {
    title: "Status",
    key: "are_credentials_active",
    togglebtn: true,
  },
  {
    title: "View Action",
    key: "",
    viewbtn: true,
  },
  {
    title: "Reset Action",
    key: "",
    resetbtn: true,
  },
];

export const itemsTableHeaders = [
  {
    title: "Item Watson ID",
    key: "item_id",
  },
  {
    title: "Item Name",
    key: "item_name",
  },
  {
    title: "Item Category",
    key: "item_category",
  },
  {
    title: "Original Transfer Quantity",
    key: "original_transfer_quantity",
  },
  {
    title: "Updated Transfer Quantity",
    key: "updated_transfer_quantity",
  },
  {
    title: "Action",
    key: "image_blob_name",
    imagebtn: true,
  },
];

export const itemsTableHeadersForConversion = [
  {
    title: "Item Watson ID",
    key: "item_id",
  },
  {
    title: "Item Name",
    key: "item_name",
  },
  {
    title: "Item Category",
    key: "item_category",
  },
  {
    title: "Quantity",
    key: "quantity",
  },
  {
    title: "Comment",
    key: "comments",
  },
  {
    title: "Target Item Type",
    key: "target_item_type",
    upperCase: true,
  },
  {
    title: "Action",
    key: "image_blob_name",
    imagebtn: true,
  },
];

export const itemsTableHeadersForDamaged = [
  {
    title: "Item Watson ID",
    key: "item_id",
  },
  {
    title: "Item Name",
    key: "item_name",
  },
  {
    title: "Item Category",
    key: "item_category",
  },
  {
    title: "Quantity",
    key: "quantity",
  },
  {
    title: "Comment",
    key: "comments",
  },

  {
    title: "Action",
    key: "image_blob_name",
    imagebtn: true,
  },
];

export const mappingTableHeaders = [
  {
    title: "Good Stock SKU",
    key: "sku",
  },
  {
    title: "GWP SKU",
    key: "gwp_sku",
  },
  {
    title: "GWP Item Description",
    key: "item_description",
  },
  {
    title: "Full Description",
    key: "full_description",
  },

  {
    title: "CTA",
    key: "",
    editIcon: true,
    delinkBtn: true,
  },
];

export const reconciliationTableHeaders = [
  {
    title: "Start Date",
    key: "start_date",
  },
  {
    title: "End Date",
    key: "end_date",
  },
  {
    title: "Status",
    key: "state",
  },
  {
    title: "Reconciliation ID",
    key: "reconciliation_id",
  },
  {
    title: "File Link",
    key: "file_id",
    downloadBtn: true,
  },
];

export const pastUploadTableHeaders = [
  {
    title: "Date",
    key: "date",
  },
  {
    title: "Uploaded By",
    key: "uploaded_by",
  },
  {
    title: "Sublocation Name",
    key: "sublocation_name",
  },
  {
    title: "Uploaded File",
    key: "uploaded_file",
  },
  {
    title: "Status",
    key: "status",
  },
  {
    title: "Reports",
    key: "reports",
  },
  {
    title: "Action",
    key: "action",
  },
];

export const replenishmentRequestTableHeaders = [
  {
    title: "Request Id",
    key: "request_id",
  },
  {
    title: "Watson Store Name",
    key: "watsan_store_name",
  },
  {
    title: "Date Of Request",
    key: "date_of_request",
  },
  {
    title: "Action",
    key: "action",
  },
];

export const replenishmentRequestDetailsTableHeaders = [
  {
    title: "SKU Name",
    key: "sku_name",
  },
  {
    title: "SKU ID",
    key: "sku_id",
  },
  {
    title: "Quantity to be Replenished",
    key: "quantity_to_be_replenished",
  },
  {
    title: "Coverage Quantity",
    key: "coverage_quantity",
  },
  {
    title: "On Hand Quantity",
    key: "on_hand_quantity",
  },
];

export const autoReplenishmenetHeaders = [
  {
    title: "Request ID",
    key: "request_id",
  },
  {
    title: "Store Name",
    key: "store_name",
  },
  {
    title: "Date & Time",
    key: "created_at",
  },
  {
    title: "Action",
    key: "",
    viewbtn: true,
  },
];
